(44 sloc)  858 Bytes

<template>
  <div v-if="$route.meta.requiresAuth">
    <div class="container-fluid" style="background: #eee;">
      <div class="row min-vh-100 flex-column flex-md-row">
        <AdminNavBar />
        <main class="col px-0 flex-grow-1">
          <AdminHeader />
          <router-view />
        </main>
      </div>
    </div>
  </div>

  <div v-else>
    <div :class="{ 'home-page': isHomePage }">
      <VisitorNavBar v-if="!$route.meta.requiresAuth && $route.path !== '/login'" />
      <router-view />
      <FooterContact v-if="!$route.meta.requiresAuth && $route.path !== '/login'" />
    </div>
  </div>
</template>

<script>
import VisitorNavBar from '@/components/VisitorNavBar.vue';
import FooterContact from '@/components/FooterContact.vue';
import AdminNavBar from '@/components/AdminNavBar.vue';
import AdminHeader from '@/components/AdminHeader.vue';


import { onBeforeMount, computed } from 'vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'

export default {
  components: {
    VisitorNavBar,
    FooterContact,
    AdminNavBar,
    AdminHeader,
  },
  setup() {
    onBeforeMount(async () => {
      await useStore().dispatch('auth/fetchUser')
    })

    const route = useRoute()
    const isHomePage = computed(() => route.path === '/')
    return { isHomePage }
  }
}
</script>